import { Deserializer } from 'jsonapi-serializer'

export const deserialize = (json: any, opts?: any) => {
  return new Deserializer({ ...opts, keyForAttribute: 'camelCase' }).deserialize(json)
}
